<form name="vm.form" class="c-form u-ost-xl" #mainForm="ngForm" novalidate>
	<div class="c-modal c-modal--sm">
		<div mat-dialog-content class="c-modal__dialog">
			<div class="c-modal__header">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p"></div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<button id="declineBookingCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.handleModalClose()">
							<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
							<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
						</button>
					</div>
				</div>
			</div>
			<div class="c-modal__content u-no-pt">
				<div class="o-media c-content u-no-p u-osb-sm">
					<p class="c-text">{{ 'Modal.Content.Booking_Cancel_Info' | translate }}</p>
				</div>
				<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': vm.submitted && reason.invalid }">
					<label for="{{ 'reason-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Modal.Form.Label.Decline_Reason' | translate }}</label>
					<textarea id="{{ 'reason-' + vm.uid }}" name="reason" class="c-form__input c-form__input--sm" [(ngModel)]="vm.booking.declineReason" #reason="ngModel" maxlength="1024" required rows="6"></textarea>
					<p class="c-text c-text--sm c-text--gray c-text--right" [ngClass]="{'c-text--s3': vm.submitted && reason.invalid }">{{ reason?.value?.length || 0 }} / 1024</p>
					<item-form-error *ngIf="vm.submitted && reason.invalid" [fieldName]="'Modal.Form.Label.Decline_Reason' | translate" [error]="reason?.errors" [noOffset]="true"></item-form-error>
				</div>
			</div>
			<div class="c-modal__footer">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
						<button id="declineBookingSubmitButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.handleFormSubmit(mainForm)" [disabled]="vm.submitted && mainForm.invalid">{{ 'Modal.Button.Cancel_Booking' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>